import React from 'react'
import styled from 'styled-components'

import { getToken as token } from 'theming'
import { Icon } from 'components/Icon'
import { Box as DefaultBox } from 'components/Layout'
import type { SortDirection } from './useSortBy.types'

import type { BoxProps } from 'components/Layout/Box'

interface TableSortHandleProps extends BoxProps {
  order?: SortDirection | null
}

const Box = styled(DefaultBox)`
  display: inline-flex;
  flex-flow: row nowrap;
  align-items: center;

  margin-left: ${token('space-xs')};
`

function TableSortHandle({ order, ...rest }: TableSortHandleProps): JSX.Element | null {
  return (
    <Box {...rest} padding="none">
      <Icon name={order != null ? `sort-${order}` : 'sort'} width="0.75em" height="0.85em" />
    </Box>
  )
}

export default TableSortHandle
